import { render, staticRenderFns } from "./jefeszonaF.vue?vue&type=template&id=b66374e0"
import script from "./jefeszonaF.vue?vue&type=script&lang=js"
export * from "./jefeszonaF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports